// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"ac33877b","157":"5fbade0b","201":"49a437e1","453":"45849238"}[chunkId] + ".chunk.js";
};